module.exports = __webpack_public_path__ + "img/fant_pack.2d699146.png";